<template>
  <div
    class="drag-icon d-flex align-center"
    data-locator="drag-icon"
    @mousedown="onMouseDown"
  >
    <AppTooltip v-if="isDragIconVisible" :disabled="isDragging">
      <template #activator="{ props }">
        <app-material-icon
          name="drag_indicator"
          color="icon-secondary"
          class="dragIcon"
          style="cursor: grab"
          v-bind="props"
          @click.stop
        />
      </template>
      <span>{{ t('dragTooltip') }}</span>
    </AppTooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState, mapMutations } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { useTranslation } from '@/common/utils/translation'
import { SET_CHECKLIST_DRAG_ITEM } from '@/store/modules/checklist/mutation_types'

export default defineComponent({
  name: 'ChecklistTableDrag',
  components: { AppTooltip },
  props: {
    draggable: {
      type: Boolean,
      default: false,
    },
    draggedItem: {
      type: Object,
    },
  },
  setup () {
    return useTranslation({ keyPrefix: 'project.checklist.ChecklistTableSelect' })
  },
  computed: {
    ...mapState('checklist', ['checklistDragItem','selectedChecklistItems']),
    isDragging (): boolean {
      return this.checklistDragItem !== null
    },
    isAwaitingValidation (): boolean {
      return this.draggedItem?.['isAwaitingValidation'] === true
    },
    isDragIconVisible (): boolean {
      return this.draggable && !this.isAwaitingValidation
    },
  },
  methods: {
    ...mapMutations('checklist', [SET_CHECKLIST_DRAG_ITEM]),

    createGhost (): HTMLElement {
      const dragGhost = document.createElement('div')

      dragGhost.classList.add('drag-ghost')
      dragGhost.textContent = ` ${this.draggedItem?.['positionDisplay'] || ''} ${this.draggedItem?.['title'] || ''}`

      if (this.selectedChecklistItems.tasks.length || this.selectedChecklistItems.sections.length) {
        const selectedItemsCounter = document.createElement('span')
        const totSelectedItems = this.selectedChecklistItems.tasks.length + this.selectedChecklistItems.sections.length

        selectedItemsCounter.classList.add('drag-ghost-counter')
        selectedItemsCounter.textContent = `+${totSelectedItems}`

        dragGhost.appendChild(selectedItemsCounter)
      }

      document.body.appendChild(dragGhost)
      return dragGhost
    },

    onMouseDown (event: MouseEvent) {
      if (!this.isDragIconVisible) return

      event.preventDefault()
      event.stopPropagation()

      this.SET_CHECKLIST_DRAG_ITEM(this.draggedItem)

      const ghost = this.createGhost()

      const onMouseMove = (e: MouseEvent) => {
        ghost.style.left = `${e.clientX + 4}px`
        ghost.style.top = `${e.clientY}px`
      }

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
        document.body.removeChild(ghost)
        this.SET_CHECKLIST_DRAG_ITEM(null)
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },

  },
})
</script>
